import React, { useMemo } from "react";
import { FormControl, FormLabel, Stack } from "@chakra-ui/react";
import { FormLabelStyle, NumberInput } from "@govisupro/controls";
import { debounce } from "lodash";
export const ControlPanel = ({ layoutItem, onUpdate, }) => {
    const pdfData = layoutItem.widget.data;
    const updatePdfData = useMemo(() => debounce((weatherData) => onUpdate === null || onUpdate === void 0 ? void 0 : onUpdate(weatherData), 300), [layoutItem, onUpdate]);
    return (React.createElement(Stack, null,
        React.createElement(FormControl, null,
            React.createElement(FormLabel, Object.assign({}, FormLabelStyle), "D\u00E9lai entre l'affichage des pages (s)"),
            React.createElement(NumberInput, { id: "pdf-delay-input", isDisabled: !pdfData.file, defaultValue: pdfData.pagesTransitionDelay, onChange: (value) => updatePdfData(Object.assign(Object.assign({}, pdfData), { pagesTransitionDelay: parseInt(value) })) }))));
};
